import { useEffect, useState } from "react";
import { axiosInstance } from "../../config/api";
import { isBirthdayWeek } from "./frameArt";

// Cache ringkas dikongsi semua kad (elak banyak panggilan API)
let _cache = null;
let _at = 0;
let _pending = null;
const listeners = new Set();

export function refreshActiveFrames() {
  _pending = axiosInstance
    .get("/photo-frames/active")
    .then((r) => { _cache = r.data; _at = Date.now(); listeners.forEach((fn) => fn(_cache)); return _cache; })
    .catch(() => { _cache = _cache || { season: null, birthday_enabled: false, show_on_cards: false }; return _cache; })
    .finally(() => { _pending = null; });
  return _pending;
}

export function useActiveFrames() {
  const [data, setData] = useState(_cache);
  useEffect(() => {
    listeners.add(setData);
    if (!_cache || Date.now() - _at > 10 * 60 * 1000) {
      (_pending || refreshActiveFrames()).then((d) => setData(d));
    }
    return () => listeners.delete(setData);
  }, []);
  return data;
}

/** Senarai bingkai yang boleh digunakan untuk seorang kanak-kanak (hari jadi diutamakan). */
export function framesForChild(child, active) {
  if (!active) return [];
  const out = [];
  if (active.birthday_enabled && isBirthdayWeek(child?.dob)) out.push("birthday");
  if (active.season?.key) out.push(active.season.key);
  return out;
}
